import React from "react";
import { MapPinIcon } from "@heroicons/react/24/solid";

interface CustomMarkerProps {
  dragging: boolean;
}

export function CustomMarker({ dragging }: CustomMarkerProps) {
  return (
    <div className="relative flex flex-col items-center">
      {/* Tooltip label */}
      <div
        className={`
          mb-2 px-2 py-1
          bg-white dark:bg-gray-800 rounded-md shadow-md
          text-xs font-medium text-gray-700 dark:text-gray-200
          whitespace-nowrap
          transition-opacity duration-200
        `}
      >
        {dragging ? "Drop to set location" : "Drag pin to set location"}
      </div>

      {/* Pin/Marker */}
      <div className="relative">
        {/* Outer circle */}
        <div
          className={`
            w-8 h-8
            bg-primary-600
            rounded-full
            border-4 border-white dark:border-gray-800
            shadow-lg
            transform -translate-x-1/2 -translate-y-1/2
            ${dragging ? "scale-110" : ""}
            transition-all duration-200
            cursor-grab
          `}
        >
          {/* Location pin icon (Heroicon MapPinIcon) */}
          <MapPinIcon
            className="w-4 h-4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white"
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  );
}
